/*
 * Countdown Timer step 3 demo (snippets/mogrt-demo-countdown.liquid), run by
 * assets/mogrt-steps-demo.js: the start time is typed over the template's
 * default, Hide Hours When Zero and Show Milliseconds tick, and the monitor
 * counts down in real time, a frame at a time: 01:00:00 drops to 59:59.966
 * and keeps going.
 */
(() => {
  // the Timer field's default in the template's panel
  const DEFAULT = '03:00:00';
  // the monitor plays at the video's 30 fps, so the milliseconds step a frame
  // at a time (.466, .433, .400 ...) the way the template renders them
  const FRAME = 1000 / 30;
  // how long it plays each loop (106 frames): it stops on .466, as the video's first millisecond frame
  const RUN = 106 * FRAME;
  // the boxes tick (and untick) 380ms + 110ms a row after [data-live] changes
  // (assets/mogrt-eg-panel.css); Show Milliseconds is row 2
  const MS_TICKS = 600;

  const pad = (n, size = 2) => String(n).padStart(size, '0');

  // HH:MM:SS, read from the right so 10:00 still means ten minutes
  const parse = (text) => {
    const [s = 0, m = 0, h = 0] = String(text).split(':').reverse().map((v) => parseInt(v, 10) || 0);
    return ((h * 60 + m) * 60 + s) * 1000;
  };

  // what the template shows for that many milliseconds left
  const format = (left, { hideHours = false, millis = false } = {}) => {
    const ms = Math.max(0, Math.floor(left));
    const h = Math.floor(ms / 3600000);
    let out = `${pad(Math.floor(ms / 60000) % 60)}:${pad(Math.floor(ms / 1000) % 60)}`;
    if (!(hideHours && h === 0)) out = `${pad(h)}:${out}`;
    return millis ? `${out}.${pad(ms % 1000, 3)}` : out;
  };

  const parts = (screen) => {
    const field = screen.querySelector('[data-eg-text]');
    field.dataset.full = field.dataset.full || field.textContent.trim();
    return { field, time: screen.querySelector('[data-mdcd-time]'), from: parse(field.dataset.full) };
  };

  window.MogrtDemos = window.MogrtDemos || {};
  window.MogrtDemos.countdown = {
    rest(screen) {
      const p = parts(screen);
      p.field.textContent = p.field.dataset.full;
      p.field.classList.remove('is-typing');
      screen.setAttribute('data-live', '');
      p.time.textContent = format(p.from - RUN, { hideHours: true, millis: true });
    },
    async pass(screen, t) {
      const p = parts(screen);
      // back to the default; the boxes untick from the last loop, Show Milliseconds last
      p.field.textContent = DEFAULT;
      p.time.textContent = format(parse(DEFAULT), { hideHours: true, millis: true });
      if (!(await t.wait(MS_TICKS))) return false;
      p.time.textContent = format(parse(DEFAULT));
      if (!(await t.wait(400))) return false;
      if (!(await t.type(p.field, p.field.dataset.full, { speed: 110 }))) return false;
      p.time.textContent = format(p.from);
      if (!(await t.wait(600))) return false;

      // Hide Hours When Zero ticks first (the hours aren't zero yet), then Show Milliseconds
      t.live(true);
      if (!(await t.wait(MS_TICKS))) return false;
      p.time.textContent = format(p.from, { hideHours: true, millis: true });
      if (!(await t.wait(800))) return false;

      // play: the hour rolls over at once, the milliseconds run
      const start = performance.now();
      await new Promise((resolve) => {
        const step = (now) => {
          if (!t.alive()) return resolve();
          const elapsed = Math.max(0, now - start);
          const played = elapsed < RUN ? Math.floor(elapsed / FRAME) * FRAME : RUN;
          const text = format(p.from - played, { hideHours: true, millis: true });
          if (p.time.textContent !== text) p.time.textContent = text;
          elapsed < RUN ? requestAnimationFrame(step) : resolve();
        };
        requestAnimationFrame(step);
      });
      return t.wait(2200);
    },
  };
})();

